import "./Wallets.scss";
import { Tabs } from "antd";
import { useState, useMemo, useEffect } from "react";
import { useSelector } from "react-redux";
import CustomCard from "../../components/CustomCard/CustomCard";
import { capitalizeEntireWord } from "../../helpers/helpers";
import WalletsTable from "./Components/WalletsTable";
import { PERM_CODE } from "../../constants/PermissionCodes";

const Wallets = () => {
  const { wallet, entBusWallet, karncyWallet } = useSelector(
    (state) => state.wallets
  );
  const { user } = useSelector((state) => state.auth);

  const userPrivileges = useMemo(
    () => user?.privilege?.map((p) => p.privilegeCode) || [],
    [user]
  );

  const allTabs = useMemo(
    () => [
      {
        key: "1",
        label: "User Wallets",
        privilege: PERM_CODE.WUACC,
        data: wallet,
      },
      {
        key: "2",
        label: "Business Enterprise Wallets",
        privilege: PERM_CODE.WBACC,
        data: entBusWallet,
      },
      // Platform Wallets tab removed
      {
        key: "4",
        label: "Karncy Wallets",
        privilege: PERM_CODE.WKACC,
        data: karncyWallet,
      },
    ],
    [wallet, entBusWallet, karncyWallet]
  );

  const visibleTabs = useMemo(
    () => allTabs.filter((tab) => userPrivileges.includes(tab.privilege)),
    [allTabs, userPrivileges]
  );

  const [activeTab, setActiveTab] = useState(null);

  useEffect(() => {
    if (visibleTabs.length) {
      setActiveTab((prev) =>
        visibleTabs.some((t) => t.key === prev)
          ? prev
          : visibleTabs[0].key
      );
    }
  }, [visibleTabs]);

  if (!visibleTabs.length) {
    return <CustomCard>No permission to view Wallets.</CustomCard>;
  }

  return (
    <CustomCard>
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        className="wallets-tabs"
        items={visibleTabs.map((tab) => ({
          key: tab.key,
          label: capitalizeEntireWord(tab.label),
          children: (
            <WalletsTable tabIndex={parseInt(tab.key)} data={tab.data} />
          ),
        }))}
      />
    </CustomCard>
  );
};

export default Wallets;
